export type IconComponentType = React.FunctionComponent<{ className?: string; strokeWidth?: string | number }>;

export type Sizes = 'sm' | 'md' | 'lg' | 'xl';

export type BadgeColors = 'gray' | 'brand' | 'error' | 'warning' | 'success' | 'dark' | 'light' | 'outOfShelf';

export type FlagTypes = 'de' | 'en'

type ExtractColorKeys<T> = T extends { styles: infer C } ? keyof C : never;
type ExtractBadgeKeys<T> = keyof T;
export type BadgeTypeToColorMap<T> = {
    [K in ExtractBadgeKeys<T>]: ExtractColorKeys<T[K]>;
};

export const badgeTypes = {
  pillColor: 'pill-color',
  badgeColor: 'color',
} as const

export type BadgeTypes = (typeof badgeTypes)[keyof typeof badgeTypes];
